export function dispatchNativeEvent (el, event) {
  var msIe = false
  var ua = window.navigator.userAgent
  var oldIe = ua.indexOf('MSIE ')
  var newIe = ua.indexOf('Trident/')
  if ((oldIe > -1) || (newIe > -1)) {
    msIe = true
  }
  if (msIe) {
    var msEvent = document.createEvent('Event')
    msEvent.initEvent(event, true, true)
    el.dispatchEvent(msEvent)
  } else {
    var otherEvent = new Event(event, {bubbles: true})
    el.dispatchEvent(otherEvent)
  }
}
